var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Vue, Prop } from 'vue-property-decorator';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import MonacoEditor from "../../../lib/comps/MaterialBox/MonacoEditor";
import "./MockButton.css";
import monacoProvider from "../../../lib/utils/monacoProvider";
import makeSchmittTrigger from "../../../lib/utils/makeSchmittTrigger";
/** 位于左侧数据源面板 鼠标悬浮可弹出mock快速启动菜单 鼠标点击可弹出mock数据管理面板 */
let MockButton = class MockButton extends Vue {
  constructor() {
    super(...arguments);
    /** 显示mock编辑窗口 */
    this.modalVisible = false;
    /** 当前选择的Mock实例的uuid */
    this.uuidSelected = '';
    /** vmodel 编辑器 */
    this.monacoValue = '';
    /** vmodel修改mock标题 */
    this.mockTitle = '';
    /** vmodel关闭mock开关 */
    this.switchValue = false;
    /** 点击按钮打开mock菜单时隐藏hover菜单 */
    this.popoverVisible = false;
    /** 帮助文档 */
    this.docLink = null;
  }
  /** designer created时创建MockState实例 切换左侧面板tab会导致MockButton被销毁 */
  created() {
    this.mockState = this.designer.mockState;
    const LINK_KEY = 'designerMock';
    const link = this.uc.config.docEnable && this.uc.config.docLink[LINK_KEY];
    this.docLink = link;
  }
  mounted() {
    // 删除 克隆 保存后 自动同步选中位置 同步monaco内容
    this.$watch(() => [this.mockState.mockList, this.uuidSelected, this.mockState.mockList.length], () => {
      this.checkSelected();
      this.refreshMonacoValue();
    });
    // 开关mock 变更选择时 同步关闭mock按钮状态
    this.$watch(() => this.mockState.isMockOn && this.uuidSelected, () => {
      this.showSwitch = this.mockState.isMockOn;
      this.switchValue = this.mockState.isMockOn;
    }, {
      immediate: true
    });
    // 关闭modal时延迟销毁
    this.$watch(() => this.modalVisible, val => this.showModal = val);
  }
  /** 检查当前选中的uuid是否有效 */
  checkSelected() {
    const mockCase = this.mockState.getMock(this.uuidSelected);
    if (!mockCase) this.uuidSelected = '';
  }
  /** 合并 [标题input,monacoEditor.value] */
  get monacoValueWithTitle() {
    return this.mockState.formatForMonaco({
      ...JSON.parse(this.monacoValue),
      mockCaseName: this.mockTitle
    });
  }
  /** 将当前选中的内容同步进editor */
  refreshMonacoValue() {
    var _this$$refs;
    if (!this.uuidSelected) return;
    const mockCase = this.mockState.getMock(this.uuidSelected);
    if (!mockCase) return;
    this.mockTitle = mockCase.mockCaseName;
    this.monacoValue = this.mockState.formatForMonaco(mockCase);
    const editor = (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.monacoContainer) === null || _this$$refs === void 0 ? void 0 : _this$$refs.editor;
    if (!editor) return;
    this.$nextTick(() => this.autoFold(editor));
  }
  /** 单选按钮列表 被hover菜单和modal复用 */
  renderRadio() {
    const h = this.$createElement;
    return h("div", [this.showSwitch && h("a-switch", {
      "class": "ucd-mockButton-closeMockSwitch",
      "on": {
        "change": checked => {
          if (checked) return;
          this.uuidSelected = '';
          this.mockState.cancelMock();
        }
      },
      "model": {
        value: this.switchValue,
        callback: $$v => {
          this.switchValue = $$v;
        }
      }
    }, [h("a-icon", {
      "slot": "checkedChildren",
      "attrs": {
        "type": "check"
      }
    }), h("a-icon", {
      "slot": "unCheckedChildren",
      "attrs": {
        "type": "close"
      }
    })]), this.mockState.mockList.map(mockCase => h("a-radio-button", {
      "class": mergeClassName('ucd-mockButton-radioButton', mockCase.uuid === this.mockState.mockCaseUsed && 'buttonActivate'),
      "attrs": {
        "value": mockCase.uuid
      }
    }, [h("a-icon", {
      "attrs": {
        "type": "clock-circle"
      }
    }), this.getTime(mockCase.createTime), mockCase.mockCaseName])), this.mockState.mockList.length === 0 && !!this.docLink && h("a-radio-button", {
      "class": "ucd-mockButton-radioButton",
      "on": {
        "click": () => window.open(this.docLink)
      }
    }, ["mock\u5E2E\u52A9\u6587\u6863"])]);
  }
  /** hover按钮时快速切换mock用例 */
  renderHoverMockList() {
    const h = this.$createElement;
    return (this.mockState.mockList.length !== 0 || this.docLink) && h("a-radio-group", {
      "class": "ucd-mockButton-radioGroup",
      "on": {
        "change": () => this.mockState.useMock(this.uuidSelected)
      },
      "model": {
        value: this.uuidSelected,
        callback: $$v => {
          this.uuidSelected = $$v;
        }
      }
    }, [this.renderRadio()]);
  }
  /** Modal左侧mock列表 */
  renderMockSourceList() {
    const h = this.$createElement;
    return h("a-radio-group", {
      "class": "ucd-mockButton-radioGroup",
      "model": {
        value: this.uuidSelected,
        callback: $$v => {
          this.uuidSelected = $$v;
        }
      }
    }, [this.renderRadio()]);
  }
  /** modal上方按钮组 */
  renderModalButton() {
    const h = this.$createElement;
    return h("div", [this.uuidSelected && h("div", {
      "class": "ucd-mockButton-modalButtonGroup"
    }, [h("a-button", {
      "key": "delete",
      "on": {
        "click": () => this.mockState.deleteMock(this.uuidSelected)
      }
    }, ["\u5220\u9664"]), h("a-button", {
      "key": "clone",
      "on": {
        "click": () => this.mockState.cloneMock(this.uuidSelected)
      }
    }, ["\u514B\u9686"]), h("a-button", {
      "key": "refresh",
      "on": {
        "click": () => this.refreshMonacoValue()
      }
    }, ["\u6062\u590D\u4FEE\u6539"]), h("a-button", {
      "key": "save",
      "on": {
        "click": async () => {
          await this.mockState.save(this.monacoValueWithTitle);
          this.$message.success('[mock]保存成功');
        }
      }
    }, ["\u4FDD\u5B58"]), h("a-button", {
      "key": "use",
      "attrs": {
        "type": "primary"
      },
      "on": {
        "click": async () => {
          const changed = this.mockState.isChangedValue(this.uuidSelected, this.monacoValueWithTitle);
          changed && (await this.mockState.save(this.monacoValueWithTitle)) && this.$message.success('[mock]自动保存成功');
          this.mockState.useMock(this.uuidSelected);
          this.modalVisible = false;
        }
      }
    }, ["\u4F7F\u7528"]), h("a-input", {
      "attrs": {
        "placeholder": 'mock标题'
      },
      "model": {
        value: this.mockTitle,
        callback: $$v => {
          this.mockTitle = $$v;
        }
      }
    })]), !this.uuidSelected && h("div", {
      "class": "ucd-mockButton-modalButtonGroup"
    }, [h("a-button", {
      "key": "collect",
      "attrs": {
        "type": "primary"
      },
      "on": {
        "click": async () => {
          this.mockState.useMock(this.uuidSelected);
          await this.mockState.collectDesignerMock();
          this.uuidSelected = this.mockState.mockCaseUsed;
        }
      }
    }, ["\u6536\u96C6\u5F53\u524D\u6570\u636E\u4F5C\u4E3Amock"]), h("div", {
      "class": "ucd-mockButton-unusedTitle"
    }, ["\u5F53\u524Dmock\u72B6\u6001:\u672A\u5F00\u542F"]), !window.mockSwitchOn && h("a-button", {
      "on": {
        "click": () => window.mockSwitchOn = true
      }
    }, [" \u663E\u793A\u9884\u89C8\u7A97\u53E3\u4E0B\u65B9\u6536\u96C6mock\u6570\u636E\u6309\u94AE "])])]);
  }
  renderHelp() {
    const h = this.$createElement;
    return h("div", {
      "class": "ucd-mockButton-helpBox"
    }, [h("div", ["mock\u529F\u80FD\u53EF\u7528\u4E8E"]), h("div", ["1.\u65B0\u9879\u76EE\u4E2D\u6570\u636E\u6E90\u7A7A\u6570\u636E"]), h("div", ["2.\u5728\u7F16\u8F91\u5668\u4E2D\u590D\u73B0\u7279\u6B8A\u6570\u636E\u72B6\u6001"]), !!this.docLink && h("a", {
      "class": "explain",
      "attrs": {
        "target": "_blank",
        "href": this.docLink
      }
    }, ["\u8BE6\u7EC6\u4F7F\u7528\u65B9\u6CD5\u89C1\u3010\u53C2\u8003\u6587\u6863\u3011"])]);
  }
  /** 弹窗左侧是mock用例选择 右侧是mock用例编辑器 底部提供对mock用例的操作*/
  renderModal() {
    const h = this.$createElement;
    return h("a-modal", {
      "attrs": {
        "title": "MockCase选择",
        "visible": this.modalVisible,
        "width": "60vw",
        "footer": null
      },
      "on": {
        "cancel": () => this.modalVisible = false
      }
    }, [this.renderModalButton(), h("div", {
      "style": "display:flex;flex-direction:row;"
    }, [this.renderMockSourceList(), !this.uuidSelected && this.renderHelp(), this.uuidSelected && h(MonacoEditor, {
      "class": "ucd-mockButton-monaco",
      "ref": "monacoContainer",
      "on": {
        "init": this.refreshMonacoValue
      },
      "model": {
        value: this.monacoValue,
        callback: $$v => {
          this.monacoValue = $$v;
        }
      }
    })])]);
  }
  /** mock用例按钮 hover态触发mock用例快速切换 click打开详细编辑界面 */
  render() {
    const h = arguments[0];
    return h("a-popover", {
      "attrs": {
        "placement": "bottomLeft",
        "trigger": ''
      },
      "on": {
        "click": () => {
          this.popoverVisible = false;
          this.modalVisible = true;
          monacoProvider(() => 0);
          this.refreshMonacoValue();
        },
        "mouseenter": async () => {
          // 触发mock数据懒加载
          await this.mockState.getMockListOnce();
          // 进入的时候按照当前的mock状态同步单选位置
          this.uuidSelected = this.mockState.mockCaseUsed;
        }
      },
      "model": {
        value: this.popoverVisible,
        callback: $$v => {
          this.popoverVisible = $$v;
        }
      }
    }, [h("template", {
      "slot": "content"
    }, [this.renderHoverMockList()]), h("div", {
      "class": "ucd-mockButton-popover"
    }, [h("a-button", {
      "class": mergeClassName('ucd-mockButton', this.mockState.isMockOn && 'activate')
    }, [this.buttonText])]), this.showModal && this.renderModal()]);
  }
  /** 从时间戳生成格式化日期 */
  getTime(timeStamp) {
    const date = new Date(timeStamp);
    const dateNumberArray = [date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes()];
    const dateArray = dateNumberArray.map(num => (Array(1).fill(0).join('') + num).slice(-2));
    return `${dateArray[0]}月${dateArray[1]}日${dateArray[2]}:${dateArray[3]} `;
  }
  /** 折叠数据源 */
  async autoFold(editor) {
    var _editor$getContributi;
    if (!editor) return;
    const foldingModel = await ((_editor$getContributi = editor.getContribution('editor.contrib.folding')) === null || _editor$getContributi === void 0 ? void 0 : _editor$getContributi.getFoldingModel());
    if (!foldingModel) return;
    const regionsInside = foldingModel.getRegionsInside(null, (r, level) => !r.isCollapsed && (level === 4 || level > 7));
    foldingModel.toggleCollapseState(regionsInside);
  }
};
__decorate([Inject(INJECT_UICORE_BUS)], MockButton.prototype, "uc", void 0);
__decorate([Inject(INJECT_UICORE_DESIGNER)], MockButton.prototype, "designer", void 0);
__decorate([Prop({
  type: String,
  default: 'M'
})], MockButton.prototype, "buttonText", void 0);
MockButton = __decorate([Component({
  name: 'MockButton',
  components: {
    MonacoEditor
  },
  data() {
    return {
      internalShowSwitch: false,
      internalShowModal: false
    };
  },
  computed: {
    // 用来延迟销毁开关
    showSwitch: makeSchmittTrigger('internalShowSwitch', 700),
    // 用来延迟销毁modal 防止monaco大小bug
    showModal: makeSchmittTrigger('internalShowModal', 800)
  }
})], MockButton);
export default MockButton;
//# sourceMappingURL=MockButton.js.map
